import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import Vue from 'vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

/* Error Tracking */
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
if (process.env.NODE_ENV === 'production') {
  Raven.config(process.env.VUE_APP_SENTRY_DSN)
    .addPlugin(RavenVue, Vue)
    .install()
}

/* Authentication */
import VueAuthenticate from 'vue-authenticate'
Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_API_ROOT,
  loginUrl: '/login/admin',
})

/* Authorization */
import { abilitiesPlugin } from '@casl/vue'
import { Can } from '@casl/vue'
import ability from '@/config/ability'

Vue.use(abilitiesPlugin, ability)
Vue.component('Can', Can)

/* Vue Filters */
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)
// Standard $date and (… | date)
import VueDateFns from 'vue-date-fns'
Vue.use(VueDateFns)
// $inWords and (… | inWords)
import { formatDistance } from 'date-fns'
function inWordsFilter(date, opts) {
  if (!date) return ''
  if (opts) {
    opts['to'] = opts['to'] || new Date()
    if (typeof opts['to'] == 'string') opts['to'] = new Date(opts['to'])
    opts['addSuffix'] = opts['addSuffix'] || false
    return formatDistance(date, opts.to, { includeSeconds: true, addSuffix: opts.addSuffix })
  } else {
    return formatDistance(date, new Date(), { includeSeconds: true, addSuffix: false })
  }
}
Vue.filter('inWords', inWordsFilter)
Vue.mixin({ methods: { $inWords: inWordsFilter } })

/* Charts */
import ApexCharts from 'vue-apexcharts'
Vue.use(ApexCharts)
Vue.component('apex', ApexCharts)

/* Vue Clipboard 2 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/* App component and global components */
import DatePicker from '@/components/DatePicker'
Vue.component('DatePicker', DatePicker)

// Monkeypatch!
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

// Copy Link for every page
import CopyButton from '@/components/CopyButton'
Vue.component('CopyButton', CopyButton)

new Vue({
  props: { root: { type: String, default: () => process.env.VUE_APP_ROOT } },
  created() {
    // Attach the Vue instance to the window, so it's available globally.
    window.Vue = this
    this.$env = process.env.NODE_ENV
    // Attach the Raven module to the instance to be able to log events
    this.$raven = Raven
    // Check the token and hydrate user data if needed
    this.$store.dispatch('auth/refresh')
    // Set the API root in case views need links to the API
    this.$api = process.env.VUE_APP_API_ROOT
    // Set the frontend application root for links to it
    this.$frontend = process.env.VUE_APP_FRONTEND_HOST
  },
  router,
  store,
  render: h => h(App),
}).$mount('#leaply')
